import { metrics } from '../metrics';

const sendMetricsHandler = ({ req = {}, res = {}, startTime }) => {
  const duration = Date.now() - startTime;
  const { method = 'get', endpointName } = req;
  const { status } = res;

  metrics.httpRequestTiming({
    method,
    status,
    duration,
    endpointName,
    isUpstream: true,
  });
};

export const axiosRequestMetrics = ({ http }) => {
  let startTime;

  http.interceptors.request.use(
    config => {
      startTime = Date.now();
      return config;
    },
    err => {
      startTime = Date.now();
      return Promise.reject(err);
    },
  );

  http.interceptors.response.use(
    res => {
      sendMetricsHandler({ req: res.config, res, startTime });
      return res;
    },
    err => {
      sendMetricsHandler({ req: err.config, res: err.response, startTime });
      return Promise.reject(err);
    },
  );
};



// WEBPACK FOOTER //
// ./src/middleware/axios.js